export default __webpack_public_path__ + "static/media/user-fallback.f1ced38f.png";